import React from 'react';
import {StyleSheet} from 'react-native';

import {backgroundXLUnlockedAlertScreen} from '../../../assets/images';
import {Button} from '../../../components/Button';
import {Text} from '../../../components/Typography';
import {Constants} from '../../../constants';
import {Messages, Strings} from '../../../constants/Strings';
import {Navigators, Screens} from '../../../constants/navigation';
import {ChamberType, Device} from '../../../lib/types';
import {StaticScreenInterstitial} from '../../../lib/types/Interstitial';
import {meetsMinimumFirmware} from '../../../lib/utils';
import {centerText} from '../../../styles';
import {StaticScreenInterstitialProps} from '../../StaticScreenInterstitial';
import {
  BodyContainer,
  ContentContainer,
  FlexImage,
  Footer,
  ImageContainer,
  Layout,
  TitleContainer,
} from '../../components/composable';

const XLUnlocked = ({
  navigation,
  onNavigatingAway,
}: StaticScreenInterstitialProps) => (
  <Layout>
    <ImageContainer style={styles.imageContainer}>
      <FlexImage source={backgroundXLUnlockedAlertScreen} />
    </ImageContainer>

    <ContentContainer>
      <BodyContainer>
        <TitleContainer>
          <Text style={centerText} variant="h2">
            {Messages.XL_UNLOCKED_ALERT_SCREEN_TITLE}
          </Text>
        </TitleContainer>

        <Text style={[centerText]}>
          {Messages.XL_UNLOCKED_ALERT_SCREEN_MSG}
        </Text>
      </BodyContainer>

      <Footer>
        <Button
          onPress={() => {
            onNavigatingAway();

            navigation.navigate(Navigators.HomeTabNavigator, {
              screen: Screens.Home,
            });
          }}>
          {Strings.DEFAULT_BTN}
        </Button>
      </Footer>
    </ContentContainer>
  </Layout>
);

const hasChamberType = (
  currentDevice: Device,
  chamberType: ChamberType | ChamberType[],
) => {
  if (
    !currentDevice?.chamberType ||
    (currentDevice.chamberType && typeof chamberType === 'number'
      ? currentDevice.chamberType !== chamberType
      : !(chamberType as number[]).includes(currentDevice.chamberType))
  )
    return false;
  return true;
};

export const XLUnlockedInterstitial: StaticScreenInterstitial = {
  key: 'xl-unlocked',
  startDate: new Date('2023-06-23'),
  type: 'static',
  display: {
    as: 'screen',
    if: ({connectedDevice, currentDevice}) => {
      if (!connectedDevice || !currentDevice) return false;

      return (
        hasChamberType(currentDevice, ChamberType.XL) &&
        meetsMinimumFirmware(
          currentDevice.softwareRevisionString ?? '',
          Constants.MINIMUM_FIRMWARE_VERSION.XL_CHAMBER,
        )
      );
    },
  },
  options: {
    screen: XLUnlocked,
  },
};

const styles = StyleSheet.create({imageContainer: {maxHeight: '50%'}});
